module.exports = __webpack_public_path__ + "media/images/Localisation-c6029d6560b9d4646d72451d3fd12221.svg";